import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { useCallback, useEffect, useState } from "react";
import {
  getObjectVersionsAsync,
  handleHideObjectLegalHoldModal,
  selectObjectLegalHoldLoading,
  selectObjectVersions,
  selectObjectVersionsLoading,
  selectShowObjectLegalHoldModal,
  setObjectLegalHoldAsync,
} from "../../../../../store/s3/buckets/objectSlice";
import { getMainVersionOfObject } from "../../../../../utils/bucket";
import { selectBucketDetails } from "../../../../../store/s3/buckets/bucketSlice";
import { Button, Modal, Switcher } from "djuno-design";

const S3ObjectLegalHoldModal = () => {
  const isOpen = useAppSelector(selectShowObjectLegalHoldModal);
  const bucketDetails = useAppSelector(selectBucketDetails);
  const versions = useAppSelector(selectObjectVersions);
  const versionsLoading = useAppSelector(selectObjectVersionsLoading);
  const mainVersion = getMainVersionOfObject(versions);
  const legalHoldLoading = useAppSelector(selectObjectLegalHoldLoading);
  const [enabledLegalHold, setEnabledLegalHold] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mainVersion) {
      setEnabledLegalHold(mainVersion.legal_hold_status === "ON");
    }
  }, [mainVersion]);

  const { handleSubmit, reset } = useForm();

  const handleClearComponent = useCallback(() => {
    reset();
    setEnabledLegalHold(false);
  }, [reset]);

  const onSubmit = (data: any) => {
    if (mainVersion && mainVersion.version_id && bucketDetails) {
      dispatch(
        setObjectLegalHoldAsync({
          bucketName: bucketDetails.name,
          prefix: mainVersion.name,
          versionId: mainVersion.version_id,
          status: enabledLegalHold ? "enabled" : "disabled",
        })
      ).then((action) => {
        if (action.type === "object/legal-hold/set/fulfilled") {
          handleClearComponent();
          dispatch(handleHideObjectLegalHoldModal());
          dispatch(
            getObjectVersionsAsync({
              bucketName: bucketDetails.name,
              prefix: mainVersion.name,
            })
          );
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleHideObjectLegalHoldModal());
    handleClearComponent();
  }, [dispatch, handleClearComponent]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      title={"Set Legal Hold"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <div className="flex items-center justify-between w-full">
            <div className="text-sm text-slate-700 dark:text-slate-200">
              Legal Hold Status
            </div>
            <Switcher value={enabledLegalHold} onChange={setEnabledLegalHold} />
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <Button
            onClick={(e) => {
              e.preventDefault();
              dispatch(handleHideObjectLegalHoldModal());
            }}
            uiType="light"
          >
            Cancel
          </Button>
          <Button
            loading={versionsLoading || legalHoldLoading}
            uiType="primary"
            disabled={versionsLoading || legalHoldLoading}
            type="submit"
          >
            Set
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default S3ObjectLegalHoldModal;
